module.exports = "https://trybtryb-legacy.web.app/img/step.0946cfb3.svg";